<template>
    <div v-if="isSupported" class="flex w-full flex-col gap-2">
        <AtomicButton
            type="button"
            size="lg"
            color="white"
            class="w-full"
            :disabled="isLoading"
            data-test="passkey-button"
            @click="verify"
        >
            <template #icon>
                <KeyRound class="mr-2 h-5 w-5" />
            </template>
            {{ label }}
        </AtomicButton>

        <p v-if="errorMessage" class="text-center text-xs text-red-600">
            {{ errorMessage }}
        </p>
    </div>
</template>

<script lang="ts" setup>
import AtomicButton from '@atomic/Buttons/AtomicButton.vue';
import { usePasskeyVerification } from '@/composables/usePasskeyVerification';
import { KeyRound } from 'lucide-vue-next';

const props = withDefaults(
    defineProps<{
        label: string;
        routes?: { options: string; submit: string };
        remember?: boolean;
    }>(),
    {
        routes: undefined,
        remember: false,
    },
);

const { verify, isLoading, isSupported, errorMessage } = usePasskeyVerification({
    routes: props.routes,
    remember: () => props.remember,
});
</script>
